import { Component, forwardRef, ElementRef, ViewChild, ChangeDetectorRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { BERetailInventoryInputModel } from '../be-retail-inventory-input.model';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { Model_BERetailDocumentLigne } from '../../be_retail.models';
import { BERetailInventoryInputService } from '../be-retail-inventory-input.service';
import { BERetailInventoryInputArticlesDialog } from '../inventory-input-articles-dialog/be-retail-inventory-input-articles-dialog.component';

@Component({
    selector: 'be-retail-inventory-input-form',
    providers: [
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => BERetailInventoryInputFormComponent),
          multi: true
      },
      {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => BERetailInventoryInputFormComponent),
          multi: true
      }
    ],
    templateUrl: './be-retail-inventory-input-form.component.html',
    styleUrls: ['./be-retail-inventory-input-form.component.scss']
})
export class BERetailInventoryInputFormComponent extends AbstractWorkflowFormComponent<BERetailInventoryInputModel, any> {
  itemsScanned: any[] = [];
  component: Model_WorkflowComponent;
  showAlert = false;
  msgAlert = '';
  @ViewChild('itemsContainer') itemsContainer: ElementRef;
  displayedColumns: string[] = ['DESIGNATION', 'QUANTITE', 'ACTION'];
  loading = false;

  constructor(
    private dialog: MatDialog,
    private _inventoryInputService: BERetailInventoryInputService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.component = this.model.additional as Model_WorkflowComponent;
  }

  doOpenArticlesDialog() {
    const dialogRef = this.dialog.open(BERetailInventoryInputArticlesDialog, {
      data: { },
      width: '100vw',
      panelClass: 'datasource-designer-modal'
    });
    
    dialogRef.afterClosed().subscribe((item?: any) => {
        if (item === undefined) { return; }
        this.addItemToInventory(item);
    });
  }

  addItemToInventory(item: any) {
    if (item.QUANTITE === undefined) { item.QUANTITE = 1; }
    const itemIndex = this.itemsScanned.findIndex(i => i.CODE_BARRE == item.CODE_BARRE);
    if (itemIndex != -1) {
      this.itemsScanned[itemIndex].QUANTITE = parseFloat(this.itemsScanned[itemIndex].QUANTITE) + 1;
    } else {
      this.itemsScanned.push(item);
    }
    this._evaluateInventoryValue();

    this.itemsContainer.nativeElement.scrollTop = this.itemsContainer.nativeElement.scrollHeight + 100;
  }

  onMinusQteButtonClicked(_itemIndex: number) {
    this.itemsScanned[_itemIndex].QUANTITE = parseFloat(this.itemsScanned[_itemIndex].QUANTITE) - 1;
    this._evaluateInventoryValue();
  }

  onPlusQteButtonClicked(_itemIndex: number) {
    this.itemsScanned[_itemIndex].QUANTITE = parseFloat(this.itemsScanned[_itemIndex].QUANTITE) + 1;
    this._evaluateInventoryValue();
  }

  onRemoveButtonClicked(_itemIndex: number) {
    this.itemsScanned.splice(_itemIndex, 1);
    this._evaluateInventoryValue();
  }

  private _evaluateInventoryValue() {
    const articles: Model_BERetailDocumentLigne[] = this.itemsScanned.map(ligne => ({ 
      CODE_BARRE: ligne.CODE_BARRE, 
      REFERENCE: ligne.REFERENCE, 
      DESIGNATION: ligne.DESIGNATION, 
      CODE_FAMILLE: ligne.CODE_FAMILLE, 
      FAMILLE: ligne.FAMILLE,
      COULEUR: ligne.COULEUR,
      TAILLE: ligne.TAILLE,
      QUANTITE: ligne.QUANTITE
    }));
    this.onValueChanged(articles);
  }

  onQteTyped(_event, rowIndex: number) {
    this.itemsScanned[rowIndex].QUANTITE = _event.detail.value;
    this._evaluateInventoryValue();
  }

  async onScanned(_scannedCode: string) {
    if (!_scannedCode) { return; }
    if (this.itemsScanned == null) { this.itemsScanned = []; }

    this.showAlert = false;
    this.msgAlert = '';
    const dbItem = this.itemsScanned.find(a => a.CODE_BARRE == _scannedCode);
    if (!!dbItem) {
      this.addItemToInventory(dbItem);
    } else {
      this.loading = true;
      try {
        const article = await this._inventoryInputService.doFindArticleBaseEtamAction(_scannedCode);
        this.addItemToInventory(article);
        this.loading = false;
      } catch(e) {
        this.msgAlert = `Aucun article ne correspond au code-barres scanné : ${_scannedCode}`;
        this.loading = false;
        this.showAlert = true;
      }
    }
    this._cdf.detectChanges();
  }
}